// API Configuration
const config = {
  development: {
    apiBaseUrl: 'http://localhost:3001'
  },
  production: {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://9scdrmw5i5.execute-api.us-east-1.amazonaws.com/dev'
  }
};

const env = process.env.NODE_ENV || 'development';

export default config[env];
